// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"ModelChart_tooltip__2-hKo","title":"ModelChart_title__1mZcJ","label":"ModelChart_label__29g3A","value":"ModelChart_value__1W7eq"};